import { withCodeNavCacheSqliteWorkLock } from '../../../sqlite/code-nav-cache/code-nav-cache-sqlite-work-lock.js';

export function withSymbolIndexSqliteLock<T>(fn: () => T | Promise<T>): Promise<T> {
  return withCodeNavCacheSqliteWorkLock(fn);
}
